import { useEffect, useRef } from 'react';
import { copy, removeFields } from '@thd-olt-functional/utils/src/utils';
import {
  useDataModel
} from '@thd-nucleus/data-sources';

import {
  params,
  string as stringType,
  arrayOf as arrayType,
  customType
} from '@thd-nucleus/data-sources/react/dataModel/prop-types';

// apollo has some race condition and because this hook is called recursively with ds
// useDataModel -> useStore -> useMembershipInformation -> useDataModel
// there is functionality in the cache for it to return in loading state for loyaltyMembership
// even when its succesfully returned and in cache. As a workaround changing fetchPolicy
// to cache-only forces it to pull from cache early.

let hasData = false;
export const useMembershipInformation = ({ customerType }) => {
  const isClient = typeof window !== 'undefined';

  if (isClient) {
    if (customerType !== 'B2B') {
      return {
        apiResponse: {
          data: null,
          error: null,
          loading: null
        },
        customerType
      };
    }
  }

  const customerProps = useRef({
    membershipInformation: null,
    svocID: null
  });

  if (isClient) {

    if (!customerProps.current.svocID) {
      customerProps.current = {
        ...customerProps.current,
        svocID: window.THDCustomer?.default?.svocID
      };
    }

    if (!customerProps.current.membershipInformation) {
      customerProps.current = {
        ...customerProps.current,
        membershipInformation: window.THDCustomer?.default?.membershipInformation
      };
    }
  }

  const savedMembershipInformation = isClient
    ? customerProps.current.membershipInformation
    : null;

  const skip = !isClient
    ? true
    : !!savedMembershipInformation;

  const options = {
    ssr: false,
    dataModel: useMembershipInformation.dataModel,
    skip,
    variables: {
      svocID: customerProps.current.svocID
    },
    fetchPolicy: hasData ? 'cache-only' : 'cache-first',
    mounted: true
  };

  const { data, loading, error } = useDataModel('loyaltyMembership', options);

  let loyaltyData = null;
  if (data) {
    hasData = true;
    const dataClone = copy(data);
    loyaltyData = removeFields(dataClone.data, ['__typename']) || { loyaltyMembership: null };
  }

  useEffect(() => {
    if (loyaltyData && !loading) {
      // eslint-disable-next-line no-unused-expressions
      window.THDCustomer?.default?.setMembershipInformation(loyaltyData.loyaltyMembership);
    }
  }, [loading]);

  if (isClient && savedMembershipInformation) {
    return {
      apiResponse: {
        data: { loyaltyMembership: savedMembershipInformation },
        error: null,
        loading: false,
      },
      customerType,
    };
  }

  return {
    apiResponse: {
      data: loyaltyData,
      error,
      loading,
    },
    customerType,
  };
};

useMembershipInformation.dataModel = {
  loyaltyMembership: params().shape({
    svocID: stringType(),
    programTiers: arrayType(customType('ProgramTiers').shape({
      tier: stringType(),
      program: stringType()
    }))
  })
};
